import React, { useEffect, useMemo, useRef, useState } from "react";
import { MasterService } from "../../../api/MasterApi/MasterApi";
import { toast } from "react-toastify";
import "./TechnologySelector.css";

function TechnologySelector({
  selectedIds = [],
  onChange,
  maxSelections = 5,
  onTechListReady,
}) {
  const [categories, setCategories] = useState([]);
  const [techByCategory, setTechByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  // const cacheRef = useRef({});

  // const { GetTechnologyCategories, GetTechnologiesByCategoryId } = useMemo(
  //   () => MasterService(),
  //   [],
  // );

  const { GetMasterAllTechnologies } = useMemo(() => MasterService(), []);
  useEffect(() => {
    loadData();
  }, []);

  // const loadData = async () => {
  //   try {
  //     setLoading(true);
  //     setError(false);
  //     const res = await GetTechnologyCategories();
  //     if (res && res.result === 1 && Array.isArray(res.result_value)) {
  //       const cats = res.result_value;
  //       setCategories(cats);
  //       await loadAllTechnologies(cats);
  //     } else {
  //       setError(true);
  //     }
  //   } catch {
  //     setError(true);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const loadData = async () => {
    try {
      setLoading(true);
      setError(false);

      const res = await GetMasterAllTechnologies();

      if (res && res.result === 1 && Array.isArray(res.result_value)) {
        const technologies = res.result_value;

        // Group by category
        const grouped = {};
        const categoryMap = {};

        technologies.forEach((item) => {
          if (!grouped[item.categoryId]) {
            grouped[item.categoryId] = [];
            categoryMap[item.categoryId] = {
              categoryId: item.categoryId,
              categoryName: item.categoryName,
            };
          }

          grouped[item.categoryId].push({
            technologyId: item.technologyId,
            technologyName: item.technologyName,
          });
        });

        setCategories(Object.values(categoryMap));
        setTechByCategory(grouped);

        if (onTechListReady) {
          onTechListReady(technologies);
        }
      } else {
        setError(true);
      }
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  // const loadAllTechnologies = async (cats) => {
  //   const results = await Promise.all(
  //     cats.map(async (cat) => {
  //       if (cacheRef.current[cat.categoryId]) {
  //         return {
  //           categoryId: cat.categoryId,
  //           techs: cacheRef.current[cat.categoryId],
  //         };
  //       }
  //       try {
  //         const res = await GetTechnologiesByCategoryId(cat.categoryId);
  //         const techs = res?.result_value?.technologies || [];
  //         cacheRef.current[cat.categoryId] = techs;
  //         return { categoryId: cat.categoryId, techs };
  //       } catch {
  //         return { categoryId: cat.categoryId, techs: [] };
  //       }
  //     }),
  //   );

  //   const map = {};
  //   results.forEach(({ categoryId, techs }) => {
  //     map[categoryId] = techs;
  //   });
  //   setTechByCategory(map);

  //   if (onTechListReady) {
  //     const flatList = results.flatMap(({ techs }) => techs);
  //     onTechListReady(flatList);
  //   }
  // };

  const handleToggle = (technologyId) => {
    const isSelected = selectedIds.includes(technologyId);
    if (!isSelected && selectedIds.length >= maxSelections) {
      toast.error(`You can select a maximum of ${maxSelections} technologies.`);
      return;
    }
    const newSelected = isSelected
      ? selectedIds.filter((id) => id !== technologyId)
      : [...selectedIds, technologyId];
    onChange(newSelected);
  };

  if (loading) {
    return (
      <div className="tech-selector-container">
        <div className="tech-selector-loading">
          <div className="tech-selector-spinner"></div>
          <span>Loading technologies...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tech-selector-container">
        <p className="tech-selector-error">
          Failed to load technologies. Please check your internet connection.
        </p>
      </div>
    );
  }

  return (
    <div className="tech-selector-container">
      {categories.map((cat) => {
        const techs = techByCategory[cat.categoryId] || [];
        if (techs.length === 0) return null;
        return (
          <div className="tech-selector-row" key={cat.categoryId}>
            <span className="tech-category-label">{cat.categoryName}</span>
            <div className="tech-chips-wrapper">
              {techs.map((tech) => (
                <button
                  key={tech.technologyId}
                  type="button"
                  className={`tech-chip${
                    selectedIds.includes(tech.technologyId)
                      ? " tech-chip--selected"
                      : ""
                  }`}
                  onClick={() => handleToggle(tech.technologyId)}
                >
                  {tech.technologyName}
                </button>
              ))}
            </div>
          </div>
        );
      })}
      <div className="tech-selector-footer">
        <span
          className={`tech-selector-count${
            selectedIds.length >= maxSelections
              ? " tech-selector-count--max"
              : ""
          }`}
        >
          {selectedIds.length} / {maxSelections} selected
        </span>
      </div>
    </div>
  );
}

export default TechnologySelector;
